import React from "react";
import "../assets/styling/brief-footer.css";
import { OPEN_PRIVACY_CHOICES_EVENT } from "./CookieConsent";

const BriefFooter = () => {
  // Required so a visitor can change their mind later, not only at first visit.
  const openPrivacyChoices = (e) => {
    e.preventDefault();
    window.dispatchEvent(new CustomEvent(OPEN_PRIVACY_CHOICES_EVENT));
  };

  return (
    <footer className="brief-footer">
      <div className="brief-footer__divider" />
      <div className="brief-footer__content">
        <p className="brief-footer__text">
          © {new Date().getFullYear()} The Boss Brief. All rights reserved.
        </p>
        <nav className="brief-footer__links" aria-label="Footer navigation">
          <a href="/privacy" className="brief-footer__link">
            Privacy
          </a>
          <a href="/terms" className="brief-footer__link">
            Terms
          </a>
          <a
            href="/privacy#choices"
            className="brief-footer__link"
            onClick={openPrivacyChoices}
          >
            Your Privacy Choices
          </a>
        </nav>
      </div>
    </footer>
  );
};

export default BriefFooter;

